"use client";

import { createContext, useContext } from "react";

export const TrialEligibilityContext = createContext<{
  eligibleCategoryIds: string[];
  isLoading: boolean;
  isTrialAvailable: boolean;
} | null>(null);

export const useTrialEligibility = () => {
  return useContext(TrialEligibilityContext);
};
